var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 622,
    width: 30,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-860 -622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 19.0625 25.55 19.0625 22.775 16.2875C22.422 15.9087 22.443 15.3155 22.8218 14.9625 23.1818 14.627 23.74 14.627 24.1 14.9625L28.475 19.3375C28.8406 19.7035 28.8406 20.2965 28.475 20.6625L24.1 25.0375C23.734 25.4031 23.141 25.4031 22.775 25.0375 22.4094 24.6715 22.4094 24.0785 22.775 23.7125L25.55 20.9375 2.1875 20.9375C1.66973 20.9375 1.25 20.5178 1.25 20 1.25 19.4822 1.66973 19.0625 2.1875 19.0625Z",
    fill: "#FFF",
    transform: "matrix(1 0 0 1.36667 860 622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 9.0625 4.45 9.0625 7.225 6.2875C7.60381 5.93453 7.62475 5.34131 7.27178 4.9625 6.91881 4.58369 6.32556 4.56275 5.94678 4.91572 5.93062 4.93075 5.91503 4.94637 5.9 4.9625L1.525 9.3375C1.15943 9.70353 1.15943 10.2965 1.525 10.6625L5.9 15.0375C6.26603 15.4031 6.85897 15.4031 7.225 15.0375 7.59056 14.6715 7.59056 14.0785 7.225 13.7125L4.45 10.9375 27.8125 10.9375C28.3303 10.9375 28.75 10.5178 28.75 10 28.75 9.48222 28.3303 9.0625 27.8125 9.0625Z",
    fill: "#FFF",
    transform: "matrix(1 0 0 1.36667 860 622)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferLogo);
export default __webpack_public_path__ + "static/media/transfer-logo.793d7d5adac1e3a781aba1535b8bc08c.svg";
export { ForwardRef as ReactComponent };